export default {
  confirm: 'confirm',
  alert: 'alert',
  changeTheme: 'changeTheme',
  orderedWine: 'orderedWine',
  wineDetail: 'wineDetail',
  producerDetail: 'producerDetail',
  currencyDetail: 'currencyDetail',
  supplierDetail: 'supplierDetail',
  grapeDetail: 'grapeDetail',
  wineStyleDetail: 'wineStyleDetail',
  evaluatorDetail: 'evaluatorDetail',
  wineTypeDetail: 'wineTypeDetail',
  produceStyleDetail: 'produceStyleDetail',
  vineyardStyleDetail: 'vineyardStyleDetail',
  regionDetail: 'regionDetail',
  countryDetail: 'countryDetail',
  districtDetail: 'districtDetail',
  subdstrictDetail: 'subdstrictDetail',
  storagePlaceDetail: 'storagePlaceDetail',
  notImplemented: 'notImplemented',
  addFilter: 'addFilter',
  bottleDetail: 'bottleDetail',
  bottleSimpleDetail: 'bottleSimpleDetail',
  imageDetail: 'imageDetail',
  classificationByOriginDetail: 'classificationByOriginDetail',
  classificationByParamsDetail: 'classificationByParamsDetail',
  flavourCharacteristicsDetail: 'flavourCharacteristicsDetail',
  winesInStockDetail: 'winesInStockDetail'
}
